"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorTypes = exports.componentTypes = exports.useFormRendererContext = void 0;
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const react_form_renderer_1 = require("@data-driven-forms/react-form-renderer");
const validator_types_1 = __importDefault(require("@data-driven-forms/react-form-renderer/validator-types"));
exports.validatorTypes = validator_types_1.default;
const FormTemplate_1 = __importDefault(require("./components/FormTemplate"));
const types_1 = require("./types");
Object.defineProperty(exports, "componentTypes", { enumerable: true, get: function () { return types_1.componentTypes; } });
const basicComponenntMapper_1 = __importDefault(require("./basicComponenntMapper"));
const FormRendererContext = react_1.default.createContext({});
const useFormRendererContext = () => react_1.useContext(FormRendererContext);
exports.useFormRendererContext = useFormRendererContext;
/**
 * FormRenderer converts JSON form definitions into fully functional React forms.
 *
 * It leverages [Data Driven Form](https://data-driven-forms.org/) with customer component mappings to use our own form controls.
 */
const FormRenderer = ({ schema, validatorMapper, onSubmit, onCancel, isSubmitting, initialValues, subscription, customComponentWrapper, }) => {
    return (react_1.default.createElement(FormRendererContext.Provider, { value: { isSubmitting } },
        react_1.default.createElement(react_form_renderer_1.FormRenderer, { componentMapper: Object.assign(Object.assign({}, basicComponenntMapper_1.default), customComponentWrapper), FormTemplate: FormTemplate_1.default, validatorMapper: validatorMapper, schema: schema, onSubmit: onSubmit, onCancel: onCancel, subscription: subscription, initialValues: initialValues })));
};
exports.default = FormRenderer;
//# sourceMappingURL=index.js.map